import { PROCESS } from "@/data/content";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { Stagger, Item } from "@/components/shared/Reveal";

export const Process = () => (
  <section data-testid="process-section" className="section relative bg-[#F4F6FA] text-navy">
    <div className="wrap">
      <SectionHeading light eyebrow="How we work" title="A structured path from requirement to running operation." />
      <Stagger className="relative mt-16 grid gap-10 md:grid-cols-5 md:gap-6" stagger={0.1}>
        <div className="absolute left-0 right-0 top-[19px] hidden h-px bg-slate-300 md:block" />
        {PROCESS.map((p, i) => (
          <Item key={p.step} data-testid={`process-step-${p.step}`} className="relative flex gap-5 md:block">
            <span className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-navy bg-[#F4F6FA] font-mono text-xs font-semibold text-navy">{p.step}</span>
            {i < PROCESS.length - 1 && <span className="absolute left-5 top-10 h-[calc(100%+1rem)] w-px bg-slate-300 md:hidden" />}
            <div className="md:mt-8 md:pr-6">
              <h3 className="font-heading text-xl font-semibold text-navy">{p.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{p.text}</p>
            </div>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);
